
import {logMessage} from "../taskpane";

export class Clusterconfig
{

    /**
     * @returns {boolean}
     */
    static isSet() {
        return localStorage.getItem('cluster_url') !== null;
    }

    /**
      * @param clusterUrl
     */
    static setUrl(clusterUrl) {
        const normalizedClusterUrl = Clusterconfig.normalizeUrl(clusterUrl);
        logMessage('Set cluster URL to ' + normalizedClusterUrl);
        localStorage.setItem('cluster_url', normalizedClusterUrl);
    }

    /**
     * @returns {string}
     */
    static getUrl(){
        if (!this.isSet()) {
            throw new Error('No cluster URL configured!');
        }
        return Clusterconfig.normalizeUrl(localStorage.getItem('cluster_url'));
    }

    /**
     *
     */
    static clear() {
        localStorage.removeItem('cluster_url');
    }

    /**
     * @param includeDev
     * @returns []
     */
    static getUrls(includeDev) {
        let clusters = [
            {label: 'Blauw', href: 'https://blauw.notarisdossier.nl', platformHref: 'https://app.notarisdossier.nl'},
            {label: 'Geel', href: 'https://geel.notarisdossier.nl', platformHref: 'https://app.notarisdossier.nl'},
            {label: 'Groen', href: 'https://groen.notarisdossier.nl', platformHref: 'https://app.notarisdossier.nl'},
            {label: 'Oranje', href: 'https://oranje.notarisdossier.nl', platformHref: 'https://app.notarisdossier.nl'},
            {label: 'Paars', href: 'https://paars.notarisdossier.nl', platformHref: 'https://app.notarisdossier.nl'},
            {label: 'Lila', href: 'https://lila.notarisdossier.nl', platformHref: 'https://app.notarisdossier.nl'},
            {label: 'Cyaan', href: 'https://cyaan.notarisdossier.nl', platformHref: 'https://app.notarisdossier.nl'},
            {label: 'Rood', href: 'https://rood.notarisdossier.nl', platformHref: 'https://app.notarisdossier.nl'},
        ];
        if (includeDev) {
            clusters.push({
                label: 'Test',
                href: 'https://testomgeving.notarisdossier.nl',
                platformHref: 'https://app.notarisdossier-test.nl',
            });
            clusters.push({
                label: 'Dev',
                href: 'https://dev.notarisdossier-test.nl',
                platformHref: 'https://app.notarisdossier-test.nl',
            });
        }
        return clusters;
    }

    /**
     * @param url
     * @returns {string}
     */
    static normalizeUrl(url) {
        return String(url || '').replace(/\/+$/, '');
    }

    /**
     * @param clusterUrl
     * @returns {boolean}
     */
    static isKnownUrl(clusterUrl) {
        const normalizedClusterUrl = Clusterconfig.normalizeUrl(clusterUrl);

        return Clusterconfig.getUrls(true).some(function (cluster) {
            return Clusterconfig.normalizeUrl(cluster.href) === normalizedClusterUrl;
        });
    }

    /**
     * @param clusterUrl
     * @returns {object|undefined}
     */
    static getCluster(clusterUrl) {
        const normalizedClusterUrl = Clusterconfig.normalizeUrl(clusterUrl);

        return Clusterconfig.getUrls(true).find(function (cluster) {
            return Clusterconfig.normalizeUrl(cluster.href) === normalizedClusterUrl;
        });
    }

    /**
     * Nested app authentication settings per Platform: the Entra app
     * registration of that Platform and the scope of its add-in API.
     *
     * @returns {{clientId: string, scope: string}|null}
     */
    static getNestedAuth() {
        const settings = {
            'https://app.notarisdossier-test.nl': {
                clientId: '008ce954-92a3-426b-811e-e81d955bae18',
                scope: 'api://008ce954-92a3-426b-811e-e81d955bae18/access_as_user',
            },
        };

        return settings[Clusterconfig.getPlatformUrl()] || null;
    }

    /**
     * @returns {string}
     */
    static getPlatformUrl() {
        const clusterUrl = Clusterconfig.getUrl();
        const cluster = Clusterconfig.getCluster(clusterUrl);

        if (cluster && cluster.platformHref) {
            return Clusterconfig.normalizeUrl(cluster.platformHref);
        }

        const legacyTestClusterUrls = [
            'https://testomgeving.notarisdossier.nl',
            'https://dev.notarisdossier-test.nl',
        ];

        if (legacyTestClusterUrls.indexOf(clusterUrl) !== -1) {
            return 'https://app.notarisdossier-test.nl';
        }

        throw new Error('Unknown cluster URL configured!');
    }

}
